import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import getRoutes from "./shared/routes";
import { makeStyles } from "@material-ui/core/styles";
import store from "./store";
import "./App.css";

function App() {
  const classes = useStyles();
  return (
    <Provider store={store}>
      <Router>
        <div className="App">
          <div className={classes.appContainer}>{getRoutes()}</div>
        </div>
      </Router>
    </Provider>
  );
}

const useStyles = makeStyles({
  appContainer: {
    width: "100%",
    margin: "auto",
  },
});

export default App;
